import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';
import { mapDivEnterToClick } from '../../misc/tools';
import './BeginScenarioUI.css'

const BeginScenarioUI = (props: UIProperties<BeginScenarioUIConfig>) => {
	const [canClick, setCanClick] = useState(true);

	props.parameters.onCanClick = () => {
		setCanClick(true);
	};
	return (
		<div className="in-game-ui-container ui-top-most-container begin-scenario-ui-container modal-disable-select" style={{
			pointerEvents: canClick ? 'all' : 'none',
            zIndex: -1
        }} 
        onKeyUp={mapDivEnterToClick}
        >
            <img className="pointer center-on-container" tabIndex={0} role='button' aria-label={`Welcome to Med Surge Level ${props.parameters.levelIndx}. Please press enter to begin your shift.`} id="first-object-main"  onClick={props.parameters.onClick} src={props.parameters.image}/>
			<div tabIndex={0} id='last-object-main' aria-label='end of u i'>

			</div>
		</div>
	);

};

export interface BeginScenarioUIConfig extends BaseConfig {
	image: string;
	/**
	 * onCanClick is called from outside this component to signal 
	 * from the flow when the user can click on the image to being the scenario
	 */
	onCanClick: () => void;
	onClick: () => void;
	levelIndx: number
}

export default BeginScenarioUI;